<template>
  <drag-modal
    :title="$t('page_my_document_advanced')"
    :subTitle="`(${$t('page_ops_machine')})`"
    :visible="visible"
    top="130px"
    width="450px"
    @close="onClose"
  >
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('page_ops_machine_search_customer_name')">
        <a-input
          v-decorator="[
            'customerName',
            {
              initialValue: undefined
            }
          ]"
          allow-clear
          :placeholder="$t('common_please_input') + $t('page_ops_machine_search_customer_name')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_machine_model_machine_name')">
        <a-input
          v-decorator="[
            'machineName',
            {
              initialValue: undefined
            }
          ]"
          allow-clear
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_name')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_machine_search_type')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-decorator="[
            'deviceTypeId',
            {
              initialValue: item.deviceTypeId || ''
            }
          ]"
          :placeholder="$t('please_select') + $t('page_ops_machine_search_type')"
          allowClear
        >
          <a-select-option v-for="(item, index) in deviceTypes" :key="index" :value="item.key">{{
            item.value
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_machine_search_state')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-decorator="[
            'assemblyState',
            {
              initialValue: item.assemblyState || ''
            }
          ]"
          :placeholder="$t('please_select') + $t('page_ops_machine_search_state')"
          allowClear
        >
          <a-select-option v-for="(item, index) in deviceStatu" :key="index" :value="item.key">{{
            item.value
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_machine_search_iot_state')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-decorator="[
            'iotState',
            {
              initialValue: item.iotState || ''
            }
          ]"
          :placeholder="$t('please_select') + $t('page_ops_machine_search_iot_state')"
          allowClear
        >
          <a-select-option :value="0">
            {{ $t('offline') }}
          </a-select-option>
          <a-select-option :value="1">
            {{ $t('online') }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_machine_search_create_time')">
        <a-range-picker
          v-decorator="[
            'createTimeRange',
            {
              initialValue: []
            }
          ]"
          :placeholder="[$t('please_select') + $t('page_ops_machine_search_create_time'),$t('please_select') + $t('page_ops_machine_search_create_time')]"
          allow-clear
        />
      </a-form-item>
    </a-form>
    <div style="text-align:center;padding-bottom:10px;" slot="footer">
      <a-button @click="save" :loading="loading" type="primary">{{ $t('common_search') }}</a-button>
      <a-button @click="onReset" style="margin-left: 10px;" type="default">{{
        $t('common_reset')
      }}</a-button>
    </div>
  </drag-modal>
</template>
<script>
import {
  DictServiceProxy,
  RegionServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'

const dbsp = new DictServiceProxy()
const dtsp = new DeviceTypeServiceProxy()

const regionSrvProxy = new RegionServiceProxy()
const customerSrvProxy = new CustomerServiceProxy()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      deviceStatu: [],
      deviceTypes: [],
      treeData: []
    }
  },
  async created() {
    await this.getDeviceStatus()
    await this.getTypeList()
    this.initTreeRootNode()
  },
  methods: {
    onReset() {
      this.form.resetFields()
      this.form.setFieldsValue({
        deviceTypeId: '',
        assemblyState: ''
      })
      this.save()
    },
    onClose() {
      // this.form.resetFields()
      this.$emit('close')
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)

          this.$emit('advanceSearch', values)
          // this.form.resetFields()
        }
      })
    },
    async getDeviceStatus() {
      const status = await dbsp.list('machine-assembly-state', '')
      this.deviceStatu = status.data[0].children.map((res) => {
        return { key: res.dictKey, value: res.dictValue }
      })
    },
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      this.deviceTypes = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
    },
    initTreeRootNode() {
      regionSrvProxy.select('').then((res) => {
        console.log('区域跟节点', res)
        this.treeData = res.data.map((c) => ({
          id: c.code,
          pId: '',
          value: c.name,
          title: c.name,
          isLeaf: false,
          isProv: false
        }))
      })
    },
    async genTreeNode(parentId) {
      const res = await regionSrvProxy.select(parentId)
      console.log({
        parentId: res.data
      })
      return res.data.map((c) => ({
        id: c.code,
        pId: parentId,
        value: c.name,
        title: c.name,
        isLeaf: c.code !== undefined && c.code !== '',
        isProv: c.code !== undefined && c.code !== ''
      }))
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        const { id } = treeNode.dataRef
        setTimeout(() => {
          this.genTreeNode(id, false).then((res) => {
            this.treeData = this.treeData.concat([...res])
          })
          resolve()
        }, 300)
      })
    }
  }
}
</script>
